<template>

  <section class="trailer">
    <!--    <section class="trailer h-7/10-screen lg:h-130-screen">-->

    <div class="blex bg-black pt-0 lg:pt-400 pb-0 lg:pb-40">
      <div class="text-white font-bold text-2xl lg:text-6xl blex pt-100 lg:pt-100-vw bottom-gradient pb-12">
        TRAILER
      </div>
    </div>

    <div class="blex relative z-5 pb-0 bg-black">
      <img src="@/assets/images/pages/main/trailer/trailerFrame.png" alt="" class="w-9/10 hidden lg:block">
      <img src="@/assets/images/pages/main/trailer/trailerFrameM.png" alt=""
           class="w-full lg:hidden block opacity-0 -z-1">


      <!--  video player        -->
      <youtube-media
          ref="youtube"
          class="video"
          :player-vars="{ autoplay: 1, loop:1, rel:0}"
          @ended="ended"
          :mute="true"
          :video-id="'Tm4jC48c6QY'"></youtube-media>
    </div>

  </section>

</template>

<script>
export default {
  nalme  : 'Trailer',
  methods: {
    ended(url) {
      if (url.target.getCurrentTime() >= url.target.getDuration() - 1) {
        url.target.seekTo(1);
      }
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  .video {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 57.5%;
    height: 750px;
    z-index: -1;

    iframe {
      width: 100%;
      height: 39.063vw; //750px
      border: unset;
    }

    @media screen and (max-width: 1024px) {
      width: 90%;
      height: 242px;

      iframe {
        height: 242px;
      }
    }
  }
}


</style>
